// extracted by mini-css-extract-plugin
export var askAiIcon = "_nc-9";
export var container = "_nc-0";
export var groupSeparator = "_nc-a";
export var highlight = "_nc-4";
export var resultIcon = "_nc-5";
export var resultItem = "_nc-7";
export var resultSubtitle = "_nc-3";
export var resultTitle = "_nc-2";
export var resultsList = "_nc-1";
export var searchGroup = "_nc-6";
export var selected = "_nc-8";